import { takeLatest, all, call, put } from "redux-saga/effects";
import { API, graphqlOperation } from "aws-amplify";

import {
  fetchCategoriesStart,
  fetchCategoriesSuccess,
  fetchCategoriesError,
  createCategoryError,
  deleteCategorySuccess,
  deleteCategoryError,
  updateCategoryError,
} from "./categories.actions";
import {
  FETCH_CATEGORIES_START,
  CREATE_CATEGORY_START,
  DELETE_CATEGORY_START,
  UPDATE_CATEGORY_START,
} from "./categories.types";
import { listCategorys } from "../../graphql/queries";
import {
  createCategory as createCategoryMuatation,
  deleteCategory as deleteCategoryMutation,
  updateCategory as updateCategoryMutation,
} from "../../graphql/mutations";
import showErrorMessage from "../../utils/showErrorMessage";

export function* fetchCategories() {
  try {
    const res = yield API.graphql({
      ...graphqlOperation(listCategorys),
      authMode: 'API_KEY',
    });

    yield put(fetchCategoriesSuccess(res.data.listCategorys.items));
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(fetchCategoriesError(errors));
  }
}

export function* createCategory({ payload }) {
  try {
    yield API.graphql(graphqlOperation(createCategoryMuatation, { input: payload.values }));
    yield put(fetchCategoriesStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(createCategoryError(errors));
  }
}

export function* deleteCategory({ payload }) {
  const input = {
    id: payload.id,
    _version: payload._version,
  };

  try {
    const res = yield API.graphql(
      graphqlOperation(deleteCategoryMutation, { input })
    );

    yield put(deleteCategorySuccess(res.data.deletePlatform));
    yield put(fetchCategoriesStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(deleteCategoryError(errors));
  }
}

export function* updateCategory({ payload }) {
  try {
    const { category, values } = payload;

    const input = {
      id: category.id,
      _version: category._version,
      ...values,
    };

    yield API.graphql(graphqlOperation(updateCategoryMutation, { input }));

    yield put(fetchCategoriesStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(updateCategoryError(errors));
  }
}

// Categories sagas
export function* onFetchCategoriesStart() {
  yield takeLatest(FETCH_CATEGORIES_START, fetchCategories);
}

// Single category sagas
export function* onCreateCategoryStart() {
  yield takeLatest(CREATE_CATEGORY_START, createCategory);
}

export function* onDeleteCategoryStart() {
  yield takeLatest(DELETE_CATEGORY_START, deleteCategory);
}

export function* onUpdateCategoryStart() {
  yield takeLatest(UPDATE_CATEGORY_START, updateCategory);
}

export function* categoriesSagas() {
  yield all([
    call(onFetchCategoriesStart),
    call(onDeleteCategoryStart),
    call(onUpdateCategoryStart),
    call(onCreateCategoryStart),
  ]);
}
